import { useEffect, useState } from "react";
import { createUserNotificationsApi } from "../api-helpers/CommonUtilsApiHelper";
import { UserNotificationInfo } from "common-util-experience-client";
import OffCanvas from "../components/offCanvas";
import NotificationsList from "./NotificationsList";


const userNotificationsApi = createUserNotificationsApi();

const NotificationsButton = () => {
    const [shoModal, setShowModal] = useState<boolean>(false);

    const [notifications, setNotifications] = useState<UserNotificationInfo[]>(
      []
    );

    useEffect(() => {
        loadNotifications();
    }, []);

    const loadNotifications = async () => {
        const { data } = await userNotificationsApi.userNotificationsControllerGetUserNotifications();
        setNotifications(data);
    }

    return <>
        <li className="menu__item">
            <a
                className="menu__link"
                href="#" onClick={() => setShowModal(true)}>
                <span className="material-symbols-outlined menu__icon">
                    notifications
                </span>
                {notifications?.length > 0 && <span className="notifications-count">{notifications.length}</span>}
            </a>
        </li>

        <OffCanvas
            title="Notifications"
            offCanvasShow={shoModal}
            setOffCanvasShow={setShowModal}
        >
            <NotificationsList notifications={notifications}
                onUpdate={n => {
                    console.log(n);
                    setNotifications(n);
                }}
                onCloseModalTrigger={() => setShowModal(false)}
            />
        </OffCanvas>
    </>;
}

export default NotificationsButton;
